import { scheduleAppointmentConsts } from "./actions"
const initState = {
    availableSlots: [
    ],
    selectedMentor: '',
    slots: [
    ],
    attendees: [],
    requestMessage: ''
}
const reducer = (state = initState, action) => {
    const payload = action.payload
    switch (action.type) {
        case scheduleAppointmentConsts.SELECT_MENTOR:
            return {
                ...state,
                selectedMentor: payload.id,
                selectedMentorProfile: payload
            }
        case scheduleAppointmentConsts.SELECT_TIME_SLOT:
            return {
                ...state,
                slots: payload
            }
        case scheduleAppointmentConsts.SELECT_ATTENDEES:
            return {
                ...state,
                attendees: payload
            }
        case scheduleAppointmentConsts.GET_AVAILABLE_SLOTS_SUCCESS:
            return {
                ...state,
                availableSlots: payload
            }
        case scheduleAppointmentConsts.GET_AVAILABLE_SLOTS_FAILURE:
            return {
                ...state,
                availableSlots: []
            }
        case scheduleAppointmentConsts.ADD_REQUEST_MESSEGE:
            return {
                ...state,
                requestMessage: payload
            }
        case scheduleAppointmentConsts.CONIRM_APPOINTMENT:
            return {
                ...state,
                appointmentConfirmedAt: new Date()
            }
        default:
            return state;
    }

};
export default reducer;
